@if (maxTextWrappedWidthInPx !== -1) {
  <div class="label-container">
    <div class="text-container" [style.max-width.px]="maxTextWrappedWidthInPx">
      {{ labelText }}
    </div>
    <div class="tooltip-container">
      <conn-tooltip
        [placement]="tooltipPlacement"
        [tooltipText]="tooltipText"
        [openDelay]="tooltipOpenDelay"
        [closeDelay]="tooltipCloseDelay"
      ></conn-tooltip>
    </div>
  </div>
} @else {
  {{ labelParts.before }}
  <span class="nowrap-label-tooltip">
    @if (labelParts.last) {
      <span>
        {{ labelParts.last }}&nbsp;
        <conn-tooltip
          [placement]="tooltipPlacement"
          [tooltipText]="tooltipText"
          [openDelay]="tooltipOpenDelay"
          [closeDelay]="tooltipCloseDelay"
          class="tooltipLabel"
        >
        </conn-tooltip>
      </span>
    }
  </span>
}
